export default "__VITE_ASSET__NnsladcB__"